import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const CommandPaletteContext = createContext(null);
export function CommandPaletteProvider({ children }) {
    const [open, setOpen] = useState(false);
    const toggle = useCallback(() => setOpen(prev => !prev), []);
    const value = useMemo(() => ({ open, setOpen, toggle }), [open, toggle]);
    return _jsx(CommandPaletteContext.Provider, { value: value, children: children });
}
export function useCommandPalette() {
    const ctx = useContext(CommandPaletteContext);
    if (!ctx)
        throw new Error('useCommandPalette must be used within CommandPaletteProvider');
    return ctx;
}
